/****************************************************************************************************************
* ©2018 EdgeVerve Systems Limited, Bangalore, India. All Rights Reserved.
*
* The EdgeVerve proprietary software program ("Program"), is protected by copyrights laws, international treaties and
* other pending or existing intellectual property rights in India, the United States and other countries. The Program
* may contain / reference third party or open source components, the rights to which continue to remain with the
* applicable third party licensors or the open source community as the case may be and nothing here transfers the
* rights to the third party and open source components, except as expressly permitted. Any unauthorized reproduction,
* storage, transmission in any form or by any means (including without limitation to electronic, mechanical, printing,
* photocopying, recording or otherwise), or any distribution of this Program, or any portion of it, may result in
* severe civil and criminal penalties, and will be prosecuted to the maximum extent possible under the law.
*****************************************************************************************************************/

import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';
import { CommonService } from '../../services/common.service';
import { SuppUserService } from '../../services/supp-user.service';

@Component({
    selector: 'app-supp-manage-group',
    templateUrl: './supp-manage-group.component.html',
    styleUrls: ['./supp-manage-group.component.scss'],
    standalone: false
})
export class SuppManageGroupComponent implements OnInit {

  title;
  heading = 'supplier.userlist.managegroup.title';
  allGroups;
  myGroups;
  notMyGroups;
  userId;
  detail;
  dropdownSettings = {
    singleSelection: false,
    textField: 'itemName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    allowSearchFilter: true,
    classes: 'user-mulit-select multi-dropdown',
    maxHeight: '20px'
  };
  constructor(private _dialogRef: MatDialogRef<SuppManageGroupComponent>, @Inject(MAT_DIALOG_DATA) private _data: any,
    private _translate: TranslateService, private _formBuilder: UntypedFormBuilder, private userService: SuppUserService,
    private commonService: CommonService) {
    console.log(_data);
    this.userId = _data.user.roleId;
    this._translate.get(this.heading).subscribe((result) =>
      this.title = result
    );
  }

  ngOnInit() {
    this.fetchGroupData();
  }
  fetchGroupData() {
    let selectedGroups, allGroups = [];
    forkJoin([
      this.userService
        .getMyGroups({ userId: this.userId })
        .pipe(
          map(res => selectedGroups = res.map(function (x) { x.itemName = x.code; return x; }))
        ),
      this.userService
        .getGroups({})
        .pipe(
          map(res => allGroups = res.map(function (x) { x.itemName = x.code; return x; }))
        )
    ])
      .subscribe(
        data => {
          this.myGroups = selectedGroups;
          this.allGroups = allGroups;
          console.log(this.myGroups, this.allGroups);
        },
        err => this.userService.openSnackBar('Error: ' + err.errorMessage)
      );
  }

  updateGroups() {
    console.log(this.myGroups);
    this.userService.updateUserGroups({ userId: this.userId, groups: this.myGroups }).toPromise()
      .then((resp) => {
        this.userService.openSnackBar('Successfully updated group mapping!');
        this.fetchGroupData();
      })
      .catch(error => this.userService.openSnackBar(error.message));
  }

}


